import styled from 'styled-components'
import { Breadcrumb } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntBreadcrumbStyled = styled(Breadcrumb)`
  &&& {
    a {
      color: ${greys.dark3};
      :hover {
        color: ${props => props.theme.colors.color1.bg};
      }
    }
  }
`

export default AntBreadcrumbStyled
